<template>
    <div v-if="bgColor == 'green'" id="header" class="green">
        <div class="wrap">
            <router-link class="home-logo" :to="{ name: 'Login'}">
                <img class="logo" src="@/assets/img/flypig.svg" alt="">
                <div class="title">飛豬管家</div>
            </router-link>
            <div class="btn-group">
                <button class="border-button" @click="clickEvent" @mouseenter="mouseEnterEvent" @mouseleave="mouseLeaveEvent">
                    App 下載
                    <qr-download v-if="showQr"></qr-download>
                </button>
                <router-link :to="{ name: 'Login'}">
                    <button class="default-button">立即註冊</button>
                </router-link>
            </div>
        </div>
    </div>
    <div v-else id="header">
        <div class="wrap">
            <router-link class="home-logo" :to="{ name: 'Login'}">
                <img class="logo" src="@/assets/img/flypig.svg" alt="">
                <div class="title">飛豬管家</div>
            </router-link>
            <div class="btn-group">
                <button class="border-button" @click="clickEvent" @mouseenter="mouseEnterEvent" @mouseleave="mouseLeaveEvent">
                    App 下載
                    <qr-download v-if="showQr"></qr-download>
                </button>
                <router-link :to="{ name: 'Login'}">
                    <button id="register" class="default-button" v-scroll-to="{ el: 'body', offset: headerOffset }">立即註冊</button>
                </router-link>
            </div>
        </div>
    </div>
</template>
<script>
import QrDownload from '@/components/widge/QrDownload.vue';
import { mapGetters } from 'vuex'

export default {
    name: "Header",
    data () {
        return {
           showQr: false
        }
    },
    props:{
        bgColor: ''
    },
    methods: {
        mouseEnterEvent: function () {
            if(this.system == 'pc'){
                this.showQr = true
            }
        },
        mouseLeaveEvent: function () {
            if(this.system == 'pc'){
                this.showQr = false
            }
        },
        clickEvent: function () {
            if(this.system != 'pc'){
                window.open(this.appUrl)
            }
        },
        register: function () {

        }
    },
    computed: {
        headerOffset: function () {
            if(this.system == 'pc'){
                return 0
            }else{
                return 200
            }
        },
        ...mapGetters({
            system: 'GET_DEVICE_SYSTEM',
            appUrl: 'GET_APP_URL'
        })
    },
    components: {
        QrDownload
    }
}
</script>
<style lang="scss" scoped>
    #header{
        position: fixed;
        width: 1440px;
        height: 65px;
        z-index: 9999;
        background: #fff;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #f0f0f0;
        .wrap{
            position: relative;
            display: flex;
            align-items: center;
            width: 100%;
            .home-logo{
                display: flex;
                align-items: center;
                .logo{
                    width: 36px;
                    height: 36px;
                    margin-left: 80px;
                    margin-right: 37px;
                }
                .title:before{
                            content: '';
                            position: absolute;
                            display: block;
                            // top: 23px;
                            top: 9px;
                            left: 135px;
                            width: 1px;
                            height: 20px;
                            background-color: #ffd9bf;
                        }
                .title{
                    font-size: 20px;
                }
            }
            
            .btn-group{
                position: absolute;
                right: 70px;
                .border-button,
                .default-button{
                    width: 124px;
                    // height: 44px;
                    font-size: 16px;
                    padding: 9px 0;
                }
                .border-button{
                    position: relative;
                    margin-right: 12px;
                    .qr-download{
                        top: 47px;
                        right: -2px;
                    }
                }
                .border-button:hover{
                    border: 1px solid #eb7859;
                    color: #eb7859;
                }
                .default-button:hover{
                    background: #eb7859;
                }
                
            }
        }
    }
    #header.green{
        background: #ff9275;
        .wrap{
            .home-logo{
                .title:before{
                    background-color: #fff;
                }
                .title{
                    color: #fff
                }
            }
            .btn-group{
                .default-button{
                    background: #fff;
                    color: #ff9275;
                }
                .border-button{
                    background: none;
                    color: #fff;
                }
                .border-button:hover{
                    border: 0;
                }
                
            }
        }
    }
    @media screen and (max-width: 1280px) {
        #header{
            width: 1280px;
        }
    }
    @media screen and (max-width: 500px) {
        #header{
            width: 100%;
            height: 49px;
            .wrap{
                .home-logo{
                    .logo{
                        width: 40px;
                        height: 40px;
                        margin-left: 16px;
                        margin-right: 22px;
                    }
                    .title:before{
                        top: 14px;
                        left: 68px;
                        height: 12px;
                    }
                    .title{
                        font-size: 16px;
                    }
                }
                .btn-group{
                    position: absolute;
                    right: 15px;
                    .border-button,
                    .default-button{
                        width: 98px;
                        height: 36px;
                        font-size: 14px;
                        line-height: 14px;
                    }
                    .border-button{
                        position: relative;
                        margin-right: 8px;
                        .qr-download{
                            display: none;
                        }
                    }
                }
            }
        }
         #header.green{
            .wrap{
                
                .btn-group{
                    .border-button{
                        margin-right: 0px;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 360px) {
        #header{
            height: 38px;
            .wrap{
                .home-logo{
                    .logo{
                        width: 31px;
                        height: 31px;
                        margin-left: 12px;
                        margin-right: 17px;
                    }
                    .title:before{
                        top: 11px;
                        left: 52px;
                        height: 9px;
                    }
                    .title{
                        font-size: 12px;
                    }
                }
                .btn-group{
                    position: absolute;
                    right: 3px;
                    .border-button,
                    .default-button{
                        width: 76px;
                        height: 28px;
                        margin-right: 8px;
                        font-size: 11px;
                        line-height: 3px;
                    }
                    .border-button{
                        position: relative;
                        .qr-download{
                            display: none;
                        }
                    }
                }
            }
        }
         #header.green{
            .wrap{
                .btn-group{
                    .border-button{
                        margin-right: 0px;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Header.vue